export default __webpack_public_path__ + "static/Cashflow 101+202-4-59c566928ea9e2b00a5424ab9a7de49f.jpg";